var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _path9, _g6, _path10, _path11, _g7, _path12, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlmAi1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_303)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 0,
    width: 6,
    height: 5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.36 0H17.57V4.77H22.36V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.32 4.74001C22.32 3.42001 21.78 2.23001 20.92 1.37001C19.68 0.140015 17.58 1.03001 17.58 2.77001C17.58 3.86001 18.46 4.73001 19.54 4.73001H22.32V4.74001Z",
    fill: "#606060"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.32 6.19H16.11C13.69 6.19 11.73 8.15 11.73 10.57H17.94C20.36 10.57 22.32 8.61 22.32 6.19Z",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_21_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 6,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.48 0H11.7V4.77H16.48V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_21_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.46 0H11.72V4.74C14.34 4.74 16.46 2.62 16.46 0Z",
    fill: "#606060"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0400085 16.16H6.24001C8.66001 16.16 10.61 14.2 10.61 11.78H4.41001C1.99001 11.78 0.0400085 13.74 0.0400085 16.16Z",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_21_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 17,
    width: 5,
    height: 6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79999 17.59H0.019989V22.33H4.79999V17.59Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_21_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.039978 17.6C0.039978 18.91 0.579978 20.1 1.43998 20.96C2.66998 22.18 4.77998 21.3 4.77998 19.56C4.77998 18.48 3.89998 17.6 2.81998 17.6H0.039978Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_21_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 17,
    width: 6,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.63 17.62H5.84V22.37H10.63V17.62Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_21_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.87 22.37H10.61V17.63C7.99 17.63 5.87 19.75 5.87 22.37Z",
    fill: "#606060"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.55 10.61V4.41001C10.55 1.99001 8.58999 0.0400085 6.17999 0.0400085V6.24001C6.17999 8.66001 8.13999 10.61 10.55 10.61Z",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_21_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 0.019989H0V4.79999H4.77V0.019989Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_21_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.74 0.039978C3.42 0.039978 2.23 0.569978 1.37 1.43998C0.15 2.66998 1.03 4.77998 2.77 4.77998C3.85 4.77998 4.73 3.89998 4.73 2.81998V0.039978H4.74Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_21_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 5,
    height: 6
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 5.84H0V10.62H4.77V5.84Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_21_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.74 10.61C4.74 8 2.62 5.88 0 5.88V10.62H4.74V10.61Z",
    fill: "#606060"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.79 11.74V17.95C11.79 20.37 13.75 22.33 16.17 22.33V16.12C16.17 13.7 14.21 11.74 11.79 11.74Z",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_21_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 6,
    height: 6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.36 17.58H17.61V22.37H22.36V17.58Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_21_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.62 22.34C18.94 22.34 20.13 21.8 20.99 20.94C22.22 19.7 21.33 17.6 19.59 17.6C18.5 17.6 17.63 18.48 17.63 19.56V22.34H17.62Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_21_303",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 11,
    width: 6,
    height: 6
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.36 11.72H17.61V16.51H22.36V11.72Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_21_303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.62 11.74C17.62 14.36 19.74 16.48 22.36 16.48V11.74H17.62Z",
    fill: "#606060"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.36,
    height: 22.37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlmAi1);
export default __webpack_public_path__ + "static/media/BlmAI_1.10c74cb6795aaa3e71394cb0adf49c4b.svg";
export { ForwardRef as ReactComponent };